"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PlatformService = void 0;
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
var _logger = _interopRequireDefault(require("./logger"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Checks support browser etc.
 */
var PlatformService = exports.PlatformService = /*#__PURE__*/function () {
  function PlatformService() {
    var _this = this;
    _classCallCheck(this, PlatformService);
    _defineProperty(this, "_knownBrowsers", ["chrome", "safari", "edge", "msie", "firefox"]);
    _defineProperty(this, "trapOn", void 0);
    _defineProperty(this, "checkWebGL", function () {
      try {
        var canvas = document.createElement("canvas");
        var result = !!window["WebGLRenderingContext"] && (canvas.getContext("webgl") || canvas.getContext("experimental-webgl"));
        if (result) _logger["default"].debug("WEBGL SUPPORTED");
        return result;
      } catch (e) {
        return false;
      }
    });
    _defineProperty(this, "chromeOnIOS", function () {
      return navigator.userAgent.match("CriOS") ? !0 : !1;
    });
    _defineProperty(this, "getIOSVersion", function () {
      return Number((navigator.userAgent.match(/\b[1-9]?[0-9]+_[0-9]+(?:_[0-9]+)?\b/) || [""])[0].split("_", 1));
    });
    /**
     * Used for resolution selection in pixi game, shitty performance on desktop safari compared to chrome
     * @returns 
     */
    _defineProperty(this, "isSafariBrowser", function () {
      return navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1;
    });
    _defineProperty(this, "getBrowser", function () {
      for (var t = 0; t < _this._knownBrowsers.length; t++) {
        if (navigator.userAgent.match(_this._knownBrowsers[t])) return _this._knownBrowsers[t];
      }
      return "UNKNOWN";
    });
    /**
     * check if browser support fullscreen Api.
     * https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
     */
    _defineProperty(this, "checkFullScreenSupport", function () {
      if ((navigator.userAgent.match("Android") && navigator.userAgent.match("Chrome")) !== null) {
        return true;
      }
      return false;
    });
    /**
     * check if we are in full screen.
     */
    _defineProperty(this, "isInFullscreen", function () {
      return document.fullscreen || document.fullscreenElement || document["webkitFullscreenElement"] || document["mozFullScreenElement"] || document["msFullscreenElement"];
    });
    /**
     * Creat trap to trigger fullscreen.
     */
    _defineProperty(this, "createFullScreenTrap", function () {
      // if we already are in fullscreen we dont try to go into it again.
      if (_this.isInFullscreen() || _this.trapOn) return;
      var parentNode = document.querySelector("body");
      var _node = document.createElement("div");
      _node.id = "apiFullscreenTrap";
      _node.style.height = "100%";
      _node.style.width = "100%";
      _node.style.zIndex = "5";
      _node.style.position = "fixed";
      parentNode.appendChild(_node);
      _this.trapOn = true;
      var _trap = function trap(e) {
        // this stop a button press as this occurs.
        e.stopPropagation();
        if (parentNode.contains(_node)) parentNode.removeChild(_node);
        var element = document.body;
        if (!_Core["default"].getState().config.fullscreen) {
          /// we wont go fullscreen even if supported
          _node.removeEventListener("touchend", _trap);
        } else if (element.requestFullscreen) {
          element.requestFullscreen().then(function () {
            _node.removeEventListener("touchend", _trap);
          })["catch"](function () {});
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
        _this.trapOn = false;
      };
      _node.addEventListener("touchend", _trap);
    });
    /** Determine if we are running in dev. */
    _defineProperty(this, "isDev", function () {
      return location.hostname === "localhost" || location.hostname === "127.0.0.1"
      // location.hostname === "stage.shock.one"
      ;
    });
    _defineProperty(this, "isIOs", function () {
      return /iPhone|iPod|iPad/.test(navigator.userAgent);
    });
    _defineProperty(this, "getIPhoneVersion", function () {
      var n = Math.max(window.screen.height, window.screen.width),
        t = Math.min(window.screen.height, window.screen.width);
      return t === 320 && n === 480 ? "4" : t === 320 && n === 568 ? "5" : t === 375 && n === 667 ? "6" : t === 414 && n === 736 ? "6+" : "none";
    });
  }
  return _createClass(PlatformService, [{
    key: "goFullScreen",
    value:
    /**
     * try to enter fullscreen, will likely fail if it does it before we
     */
    function goFullScreen() {
      if (this.isInFullscreen) return;
      document.body.requestFullscreen()["catch"](function () {
        // swallow error
      });
    }
  }]);
}();
var platformService = new PlatformService();
var _default = exports["default"] = platformService;
//# sourceMappingURL=platformService.js.map